// Poké Balls des variantes (icônes Pokémon HOME, 32 px, relevées sur
// Poképédia le 2026-09-26 — sans celles exclusives à Légendes).
// Une ball par variante standard ; les balls restantes sont distribuées
// aux variantes perso (stable par id, cf. ballForCustom).
import poke from "../assets/balls/ball-poke.png";
import superBall from "../assets/balls/ball-super.png";
import hyper from "../assets/balls/ball-hyper.png";
import master from "../assets/balls/ball-master.png";
import luxe from "../assets/balls/ball-luxe.png";
import honor from "../assets/balls/ball-honor.png";
import chrono from "../assets/balls/ball-chrono.png";
import rapide from "../assets/balls/ball-rapide.png";
import sombre from "../assets/balls/ball-sombre.png";
import soin from "../assets/balls/ball-soin.png";
import filet from "../assets/balls/ball-filet.png";
import scuba from "../assets/balls/ball-scuba.png";
import bis from "../assets/balls/ball-bis.png";
import lune from "../assets/balls/ball-lune.png";
import speed from "../assets/balls/ball-speed.png";
import safari from "../assets/balls/ball-safari.png";
import reve from "../assets/balls/ball-reve.png";
import memoire from "../assets/balls/ball-memoire.png";
import appat from "../assets/balls/ball-appat.png";
import niveau from "../assets/balls/ball-niveau.png";
import love from "../assets/balls/ball-love.png";
import faiblo from "../assets/balls/ball-faiblo.png";
import copain from "../assets/balls/ball-copain.png";

// Catalogue des 23 balls, une entrée par clé stable — sert à la fois aux
// mappings fixes ci-dessous et au picker de Réglages > Balls de rareté
// (lib/api.js fetchRarityBalls renvoie des clés de ce dictionnaire).
export const BALL_DEFS = {
  poke:    { src: poke,      name: "Poké Ball" },
  super:   { src: superBall, name: "Super Ball" },
  hyper:   { src: hyper,     name: "Hyper Ball" },
  master:  { src: master,    name: "Master Ball" },
  luxe:    { src: luxe,      name: "Luxe Ball" },
  lune:    { src: lune,      name: "Lune Ball" },
  honor:   { src: honor,     name: "Honor Ball" },
  chrono:  { src: chrono,    name: "Chrono Ball" },
  rapide:  { src: rapide,    name: "Rapide Ball" },
  sombre:  { src: sombre,    name: "Sombre Ball" },
  soin:    { src: soin,      name: "Soin Ball" },
  filet:   { src: filet,     name: "Filet Ball" },
  scuba:   { src: scuba,     name: "Scuba Ball" },
  bis:     { src: bis,       name: "Bis Ball" },
  speed:   { src: speed,     name: "Speed Ball" },
  safari:  { src: safari,    name: "Safari Ball" },
  reve:    { src: reve,      name: "Rêve Ball" },
  memoire: { src: memoire,   name: "Mémoire Ball" },
  appat:   { src: appat,     name: "Appât Ball" },
  niveau:  { src: niveau,    name: "Niveau Ball" },
  love:    { src: love,      name: "Love Ball" },
  faiblo:  { src: faiblo,    name: "Faiblo Ball" },
  copain:  { src: copain,    name: "Copain Ball" },
};

// Variantes standard : mapping fixe, pas éditable depuis Réglages (choix du
// 2026-10-03, revu une fois avec l'utilisateur).
export const VARIANT_BALL = {
  normal:       BALL_DEFS.poke,
  reverse:      BALL_DEFS.super,
  holo:         BALL_DEFS.honor,     // holo "ordinaire", sans rareté spéciale
  firstEdition: BALL_DEFS.memoire,
  wPromo:       BALL_DEFS.bis,
  cosmos:       BALL_DEFS.chrono,    // holo Cosmos (ex. Évoli 30th-116)
  rgb:          BALL_DEFS.reve,      // les 3 Mew du 30ᵉ Anniversaire
};
// Clés réservées aux variantes ci-dessus : jamais proposées dans le picker
// de Réglages > Balls de rareté (sinon deux significations différentes
// porteraient la même ball).
export const STANDARD_BALL_KEYS = new Set(["poke", "super", "honor", "memoire", "bis", "chrono", "reve"]);

// Beaucoup de raretés spéciales modernes (ex, AR, SAR, Gold/Secret, V/VMAX...)
// n'ont, côté TCGdex, qu'une seule variante "holo" — elles partageaient donc
// toutes la même ball, rendant ces raretés très différentes indiscernables
// d'un coup d'œil. Une ball dédiée par PALIER de rareté (lib/rarity.js, même
// `tier`) prend le dessus sur la ball "holo ordinaire" ci-dessus quand la
// variante est "holo". Valeurs par défaut (overridables depuis Réglages >
// Balls de rareté, cf. ballForVariant) choisies avec l'utilisateur le
// 2026-10-03 — pika/promo/ace volontairement regroupés sur la même ball
// (« tout ce qui est un peu étrange, pas de quoi mériter 3 balls à part »).
export const RARITY_BALL_DEFAULT = {
  double: BALL_DEFS.hyper,   // ex ("Double rare")
  ultra:  BALL_DEFS.rapide,  // V/VMAX/VSTAR/GX/Prime/Legend/BREAK
  ir:     BALL_DEFS.niveau,  // Illustration Rare (AR)
  sir:    BALL_DEFS.master,  // Illustration Spéciale Rare (SAR)
  hyper:  BALL_DEFS.love,    // Hyper rare / Futuristic / Rainbow / Gold
  secret: BALL_DEFS.love,    // Secret rare (même ball que Hyper, même traitement visuel en rareté)
  pika:   BALL_DEFS.soin,    // promo Pikachu
  promo:  BALL_DEFS.soin,    // promo générique
  ace:    BALL_DEFS.soin,    // ACE SPEC
  shiny:  BALL_DEFS.lune,    // chromatique/brillant/radieux
};

// Balls disponibles pour les variantes perso (hash-assignées, cf.
// ballForCustom) : le reste du pool une fois variantes standard + raretés
// par défaut retirées. Fixe — ne suit pas les overrides de Réglages, pour
// ne pas faire bouger les balls perso déjà attribuées à chaque changement
// de rareté ailleurs.
export const EXTRA_BALLS = [
  BALL_DEFS.luxe, BALL_DEFS.sombre, BALL_DEFS.filet, BALL_DEFS.scuba,
  BALL_DEFS.speed, BALL_DEFS.safari, BALL_DEFS.reve, BALL_DEFS.appat,
  BALL_DEFS.faiblo, BALL_DEFS.copain,
];

// Ball d'une variante perso : choisie de façon STABLE à partir de son id
// (même variante → même ball sur toutes les cartes et tous les écrans).
export function ballForCustom(customId) {
  let h = 0;
  for (const ch of String(customId || "")) h = (h * 31 + ch.charCodeAt(0)) >>> 0;
  return EXTRA_BALLS[h % EXTRA_BALLS.length];
}

// Cache module : évite d'avoir à faire passer les overrides de Réglages à
// travers chaque vue qui dessine une carte (OwnedCardsView, WantedView,
// GlobalBrowseView, CollectionValueView, CustomListsView, FriendListView,
// SetDetailView, BinderGrid, CrossRarityView...). useRarityBalls (App.js)
// la tient à jour à chaque chargement/modification — un seul fetch pour
// toute l'appli, lu en synchrone par ballForVariant.
let _rarityBallCache = {};
export function setRarityBallCache(map) { _rarityBallCache = map || {}; }

// `overrides` : {clé -> ball_key} renvoyé par GET /api/rarity-balls (ou le
// cache module ci-dessus si omis) — la clé est soit un palier connu
// (double/ultra/ir/sir/hyper/secret/pika/promo/ace/shiny), soit le texte
// EXACT d'une rareté inhabituelle qu'aucun palier ne couvre ("truc vraiment
// spécial", ajouté depuis Réglages). Le texte brut est vérifié EN PREMIER :
// plus précis qu'un palier, donc prioritaire.
export function ballForVariant(type, customId, rarityTier, rawRarity, overrides) {
  if (type === "holo") {
    const ov = overrides || _rarityBallCache;
    const rawKey = ov[rawRarity];
    if (rawKey && BALL_DEFS[rawKey]) return BALL_DEFS[rawKey];
    const tierKey = rarityTier && ov[rarityTier];
    if (tierKey && BALL_DEFS[tierKey]) return BALL_DEFS[tierKey];
    if (rarityTier && RARITY_BALL_DEFAULT[rarityTier]) return RARITY_BALL_DEFAULT[rarityTier];
  }
  if (VARIANT_BALL[type]) return VARIANT_BALL[type];
  return ballForCustom(customId || type);
}
